var React = require('react');

function ArrowRightBlueInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.666748 5.3333V6.66664H8.66675L5.00008 10.3333L5.94675 11.28L11.2267 5.99997L5.94675 0.719971L5.00008 1.66664L8.66675 5.3333H0.666748Z","fill":"#004CBF"}));
}

ArrowRightBlueInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowRightBlueInline;

ArrowRightBlueInline.default = ArrowRightBlueInline;
